export const emailRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;

export const letterRegex = /^[a-z\s]*$/i;

export const phoneRegex = /^[(]?[+]?[0-9]{0,3}[)]?[-\s.]?[0-9]{3}[-\s.]?[0-9]{3}[-\s.]?[0-9]{4,6}$/im;

export const positionRegex = /^[a-z()-\s]*$/i;

export const validSMS = /^[a-zA-Z0-9~!@#$%^&*()`[\]{};':,./<>?| ]*$/;

export const propertyNameReg =
  /^[1234567890a-zA-ZàáâäãåąčćęèéêëėįìíîïłńòóôöõøùúûüųūÿýżźñçčšžÀÁÂÄÃÅĄĆČĖĘÈÉÊËÌÍÎÏĮŁŃÒÓÔÖÕØÙÚÛÜŲŪŸÝŻŹÑßÇŒÆČŠŽ∂ð ,.&'-]+$/u;

export const accountDisplayNameReg =
  /^[1234567890a-zA-ZàáâäãåąčćęèéêëėįìíîïłńòóôöõøùúûüųūÿýżźñçčšžÀÁÂÄÃÅĄĆČĖĘÈÉÊËÌÍÎÏĮŁŃÒÓÔÖÕØÙÚÛÜŲŪŸÝŻŹÑßÇŒÆČŠŽ∂ð ,.&'/-]+$/u;

export const propertyNameSpecialReg = /[^A-Za-z0-9&'\s]+/g;

export const accountDisplayNameSpecialReg = /[^A-Za-z0-9&'/\s]+/g;

export const propertySubdomainSpecialReg = /[^A-Za-z0-9\s-]+/g;

export const uppercaseReg = /[^A-Z\s]+/g;

export const hexColorRegWithoutHash = /^([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/;
